<template>
  <div class="row">
    <div class="col-12 col-md-7">
      <div class="modal-text">
        <article class="reason">
          <h4>{{ $t('more_info.overview') }}</h4>
          <div v-html="moreInfo.important_info"></div>
        </article>
      </div>
    </div>
    <div class="col-12 col-md-5">
      <lounge-right-col />
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import mixins from "@/mixins";
import { LoungeRightCol } from "@/components";

export default {
  name: "LoungeOverview",
  mixins: [mixins.validate, mixins.globals, mixins.format], 
  components: { LoungeRightCol },
  computed: {
    moreInfo: sync("modals/moreInfo")
  }
};
</script>